import { Suspense, useEffect, useState } from "react"
import SimpleBackdropLoader from "../BackdropLoading/BackdropLoading"
import { loadExtension } from "../../utils/loadExtension"
import { useLocalization } from "../../providers/LocalizationProvider"

const DynamicComponentRenderer = ({ componentKey, componentName, componentProps = {}, appKey }) => {
    const [DynamicComponent, setDynamicComponent] = useState(null)
    const [pageReady, setPageReady] = useState(0)
    const [error, setError] = useState(null)
    const { voiceiiTags } = useLocalization()

    useEffect(() => {
        async function init() {
            try {
                await loadExtension(componentName, appKey)
                setPageReady((prev) => prev + 1)
            } catch (err) {
                console.warn("Extension loading failed:", err)
                setError(true)
            }
        }

        init()
    }, [componentName, appKey])

    useEffect(() => {
        const Component = window?.ExtensionPages?.DynamicComponents?.[componentKey]
        setDynamicComponent(() => Component)
    }, [componentKey, pageReady])

    // ❌ error fallback
    if (error) {
        return <div>{voiceiiTags("Something went wrong while loading this extension.")}</div>
    }

    // ⏳ optional loader
    if (!DynamicComponent) {
        return <SimpleBackdropLoader showLoader={!DynamicComponent} />
    }
    if (!DynamicComponent) {
        return <div>{voiceiiTags("Component not found")}</div>
    }

    // If the extension runtime registers `React.lazy` components, they need a Suspense boundary.
    return (
        <Suspense fallback={<SimpleBackdropLoader showLoader />}>
            <DynamicComponent {...componentProps} />
        </Suspense>
    )
}

export default DynamicComponentRenderer
